// extracted by extract-css-chunks-webpack-plugin
module.exports = {"children":"rJfxbxwGQCmcRuJrIYLe","collapse":"AVHaMXDqUUj0B9iwfuh1"};